import React from "react";
import { Container } from "react-bootstrap";
import MainSubHeading from "../Sub-Heading/MainSubHeading";
import computerGraphic from "../../assets/jobsProfile/JD-COMPUTER-GRAPHICS-ENG.pdf"
import halthcareAiInterns from "../../assets/jobsProfile/HAI-Interns-Recruitment-2025.pdf"
import youngResearcherInternship from "../../assets/jobsProfile/Young-Research-Internship-Program.pdf"
import projectAssistant from "../../assets/jobsProfile/Project-Assistant-Medical-Data-Curation.pdf";
import linuxSystemAdmin from "../../assets/jobsProfile/Linux-System-Administrator.pdf";
import youngResearcherFellow from "../../assets/jobsProfile/Young-Research-Fellow-(YRF).pdf";
import projectAssistant1 from "../../assets/jobsProfile/Project_Assistant.pdf";
import computerVisionEngg from "../../assets/jobsProfile/Computer_Vision_Engineer_JD.pdf";
import juniorROS2Engg from "../../assets/jobsProfile/Jr.ROS2_Engg_JD.pdf";
import fullStackDeveloper from "../../assets/jobsProfile/FULLSTACK_ENGG_JD_2025.pdf";
import juniorRoboticsSoftwareEngg from "../../assets/jobsProfile/Jr.Robotics_Software_Engineer.pdf";
import Fellow_Comp_Chem from "../../assets/jobsProfile/Postdoctoral_Fellow_in_Computational_Chemistry.pdf";
import Pro_Ass_posi_Comp_Chem from "../../assets/jobsProfile/Project_Assistant_position_in_Computational_Chemistry.pdf";
import Research_Fellow_in_Genomics_for_Microlabs from "../../assets/jobsProfile/Research-Fellow-in-Genomics-for-Microlabs.pdf";
import Partnership_JD_June_2026 from "../../assets/jobsProfile/2026/Partnership_JD_June_2026.pdf";
import BD_Mobility_deeptech_JD_June_2026 from "../../assets/jobsProfile/2026/BD_Mobility_deeptech_JD_June_2026.pdf";
import BD_Healthcare_JD_June_2026 from "../../assets/jobsProfile/2026/BD_Healthcare_JD_June_2026.pdf";
import Deployment_Engineer_July_2026 from "../../assets/jobsProfile/2026/Deployment_Engineer_July_2026.pdf";
import BDM_Programs_Partnerships_Sept_2026 from "../../assets/jobsProfile/2026/BDM_Programs&Partnerships_Sept_2026.pdf";

export default function Careers() {
  const subheadingData = "WORK WITH US"
  return (
    <div>
      <Container>
        <MainSubHeading subheading={subheadingData} />
        <div className="py-md-3">
          <p>
          IHub-Data is on the lookout for passionate and talented individuals who are ready to shape the future with innovation and creativity. If you are passionate about creating real impact, we invite you to explore our exciting career opportunities.
          </p>
          <p>Discover Your Next Role:</p>
          <p>Click below to view all our current openings.</p>
          <ul>
            <li className="py-2">
              <a href={BDM_Programs_Partnerships_Sept_2026} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Business Development Manager – UDAAN (Programs & Partnerships)</a>
            </li>
            <li className="py-2">
              <a href={Deployment_Engineer_July_2026} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Deployment Engineer – Inter-Hub Systems & Platform Operations</a>
            </li>
            <li className="py-2">
              <a href={Partnership_JD_June_2026} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Partnerships, Proposals & Funding Manager</a>
            </li>
            <li className="py-2">
              <a href={BD_Healthcare_JD_June_2026} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Business Development Manager – Healthcare Innovations</a>
            </li>
            <li className="py-2">
              <a href={BD_Mobility_deeptech_JD_June_2026} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Business Development Manager – Mobility & DeepTech Solutions</a>
            </li>

            
            <li className="py-2">
              <a href={Research_Fellow_in_Genomics_for_Microlabs} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Research Fellow in Genomics for Microlabs</a>
            </li>
            <li className="py-2">
              <a href={Fellow_Comp_Chem} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Postdoctoral Fellow in Computational Chemistry</a>
            </li>
            <li className="py-2">
              <a href={Pro_Ass_posi_Comp_Chem} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Project Assistant Positions in Computational Chemistry</a>
            </li>
            <li className="py-2">
              <a href={computerVisionEngg} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Computer Vision Engineer</a>
            </li>
            <li className="py-2">
              <a href={juniorROS2Engg} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Junior ROS 2 Engineer</a>
            </li>
            <li className="py-2">
              <a href={fullStackDeveloper} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Full Stack Developer</a>
            </li>
            <li className="py-2">
              <a href={juniorRoboticsSoftwareEngg} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Junior Robotics Software Engineer</a>
            </li>

            <li className="py-2">
              <a href={projectAssistant1} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Project Assistant</a>
            </li>
            <li className="py-2">
              <a href={youngResearcherFellow} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Young Research Fellow (YRF)</a>
            </li>
            <li className="py-2">
              <a href={projectAssistant} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Project Assistant – Medical Data Curation</a>
            </li>
            <li className="py-2">
              <a href={linuxSystemAdmin} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Linux System Administrator</a>
            </li>
            <li className="py-2">
              <a href={computerGraphic} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Computer Graphics Engineer</a>
            </li>
            <li className="py-2">
              <a href={halthcareAiInterns} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Healthcare & AI Interns</a>
            </li>
            <li className="py-2">
              <a href={youngResearcherInternship} target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">Young Research Internship Program</a>
            </li>
          </ul>

          <p>Please Note: Clicking the link will open a new tab.</p>
        </div>
      </Container>
    </div>
  );
}
